'use strict';

import React from 'react';
import NewsItemComponent from './NewsItemComponent.js'
import { Carousel } from 'react-bootstrap'

require('styles//NewsSection.css');

class NewsSectionComponent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      newsArray: []
    }
  }

  componentDidMount() {
    return fetch('/api/v1/news/')
      .then((response) => response.json())
      .then((responseJson) => {
        this.setState({
          newsArray: responseJson
        })
      })
      .catch(() => {

      });
  }

  render() {
    const listNews = this.state.newsArray.map((news) =>
      <Carousel.Item className="news" key={news.title}>
        <NewsItemComponent news={news} />
      </Carousel.Item>
    );
    return (
      <div className="newssection-component">
        <div className="title">Notícias | </div>
        <div className="news-array">
          <Carousel interval={5000} indicators={false} controls={false}>
            {listNews}
          </Carousel>
        </div>
      </div>
    );
  }
}

NewsSectionComponent.displayName = 'NewsSectionComponent';

// Uncomment properties you need
// NewsSectionComponent.propTypes = {};
// NewsSectionComponent.defaultProps = {};

export default NewsSectionComponent;



// WEBPACK FOOTER //
// ./src/components/NewsSectionComponent.js